import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import MuiButton from "../shares/MuiButton";
import useFetch from "../../context/useFetch";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "jalali-moment";

// Others File

const NotificationsDetails = () => {
  const [data, setData] = useState(undefined);
  const { id } = useParams();
  const getNotifData = useFetch({
    method: "get",
    noHeader: true,
    url: `Notif_Service/${id}`,

    trigger: true,
    setter: setData,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  return (
    <>
      <div className="hp-section-one">
        <Navbar activePage="notifications" />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">اطلاعیه‌ها</p>
        <div className="border border-myorange-400 rounded-lg mt-8 p-4">
          <div className="bg-myorange-300 rounded-lg py-2 px-4 flex justify-between">
            <span className="font-bold text-mygray-700">{data?.title}</span>
            <span className="text-mygray-700 font-thin text-sm">
              تاریخ:{" "}
              {data !== undefined &&
                moment(data?.created_at, "YYYY/MM/DD")
                  .locale("fa")
                  .format("YYYY/MM/DD")}
            </span>
          </div>
          <p className="text-sm leading-8 text-mygray-700 mt-6">
            {data?.description}
          </p>
        </div>
        <a href={data?.attach_file} download>
          <div className="flex justify-end mt-9">
            <MuiButton
              withoutOnClick
              type="submit"
              variant="contained"
              color="primary"
              text="دانلود فایل PDF"
            />
          </div>
        </a>
      </div>
    </>
  );
};
export default NotificationsDetails;
